import React, { InputHTMLAttributes } from 'react';
import cn from 'classnames';
import styles from './styles.module.css';

export interface CheckboxProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  label?: string;
  name: string;
  error?: string;
  defaultClassName?: string;
  checked: boolean;
  labelClassName?: string;
  labelTitle?: string;
  showFadeOut?: boolean;
  testId?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  (
    {
      className,
      label,
      name,
      error,
      onChange,
      defaultClassName,
      checked,
      labelClassName,
      labelTitle,
      showFadeOut = false,
      testId,
      disabled,
      ...rest
    },
    ref
  ) => {
    const baseTestId = testId || `checkbox-${name}`;
    return (
      <div className={className} data-testid={`${baseTestId}-root`}>
        <div className={styles.ccCheckboxWrapper} data-testid={`${baseTestId}-wrapper`}>
          <input
            id={name}
            name={name}
            checked={checked}
            type="checkbox"
            ref={ref}
            data-testid={`${baseTestId}-input`}
            className={cn(
              styles.ccCheckbox,
              `${defaultClassName ? styles[defaultClassName] : ''}`,
              {
                '!cursor-normal': disabled,
                '!cursor-pointer': !disabled,
              }
            )}
            disabled={disabled}
            onChange={onChange}
            {...rest}
          />

          <label
            title={labelTitle}
            htmlFor={name}
            data-testid={`${baseTestId}-label`}
            className={cn(styles.ccCheckboxLabel, labelClassName, {
              '!cursor-normal': disabled,
              '!cursor-pointer': !disabled,
            })}
          >
            {label}
            {showFadeOut && <span className={styles.fadeOut}></span>}
          </label>
        </div>

        {error && <p className={styles.ccCheckboxError} data-testid={`${baseTestId}-error`}>{error}</p>}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
